import React, { useState } from "react";

import styles from "../styles/qrCode.module.css";
import VideoList from "../components/videolist";

const Videos = () => {

    return (
        <div className={styles.page_container}>
            <div className={styles.main_content}>
                <div className={styles.text_center}>
                    <h1 className={styles.main_heading}>Discover Our Healthcare Solutions</h1>
                    <p className={styles.description}>
                        Play video or scan the QR code to watch a demonstration of our Remote Patient Monitoring (RPM)
                        and Chronic Care Management (CCM) services.
                    </p>
                </div>

            </div>
            <VideoList />
        </div>
    );
};

export default Videos;
